'use client';

import Image from 'next/image';
import { IReview } from 'types/src/types';
import { StarRating } from './StarRating';
import { Report } from '../../bits/components/Report';
import { useBoolean } from '@/src/hooks/use-boolean';

export const ReviewsList = ({ reviews }: { reviews: IReview[] }) => {
  const isReportOpen = useBoolean(false);

  if (reviews.length === 0) {
    return <p className="text-center py-10 text-gray-500">No reviews yet.</p>;
  }

  return (
    <ul style={{ listStyleType: 'none', padding: 0 }}>
      {reviews.map((review) => (
        <li key={review.id} className="p-4 gap-4">
          <div className="flex justify-between">
            <div className="flex items-center gap-3">
              <Image
                src={review.author?.avatarUrl || '/images/user.png'}
                alt={review.author?.fullName || ''}
                width={40}
                height={40}
                className="rounded-full"
              />
              <div className="flex flex-col items-start gap-1.5">
                <span className="text-base font-medium">
                  {review.author?.fullName}
                </span>
                <StarRating rating={review.rating} />
              </div>
            </div>
            <Report
              type="review"
              reviewId={review.id}
              projectId={review.project?.id}
              open={isReportOpen.value}
              onOpenChange={isReportOpen.setValue}
            />
          </div>
          <p className="mt-4 text-gray-700 ml-13 whitespace-pre-line">
            {review.text}
          </p>
          <hr className="my-4 border-t" />
        </li>
      ))}
    </ul>
  );
};
